import { render, staticRenderFns } from "./SuperTalkDetails.vue?vue&type=template&id=d7bd3088&scoped=true"
import script from "./SuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./SuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./SuperTalkDetails.vue?vue&type=style&index=0&id=d7bd3088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bd3088",
  null
  
)

export default component.exports